import { constants } from "../../../constants";

export default class BetAmountChange {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data) {
        if(data.payload && data.payload.betAmount) {
            this.gb.betAmount = data.payload.betAmount;
        }

        this.gb.emitters.emit.web.betAmountChange(data);

        if(this.gb.api && this.gb.api.modules && this.gb.api.modules.superWheel.instanceAvailable) {
            this.gb.api.modules.superWheel.initWheel();
            this.gb.api.modules.superWheel.updateTotalBet();
        }
    }

    ENDOR_handler(payload) {
        if (payload && payload.totalBet) {
            this.gb.emitters.emit.web.betAmountChange(payload.totalBet);
        }
    }

    PLS_handler(payload) {
        if (payload && payload.data && payload.data.length > 0) {
            this.gb.emitters.emit.web.betAmountChange(payload.data[0]);
        }
    }

    SSG_handler(payload) {

        if (payload && payload.data && payload.data.totalBet > 0) {
            this.gb.emitters.emit.web.betAmountChange({payload: { betAmount: payload.data.totalBet}});
        }
    }

    WZD_handler(payload) {
        if (payload && payload.param && payload.param.stake > 0) {
            this.gb.emitters.emit.web.betAmountChange({payload: { betAmount: payload.param.stake}});
        }
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.PLS:
                event["gameChangeBet"] = this.PLS_handler;
                break;
            case constants.ENDOR:
                event["betChanged"] = this.ENDOR_handler;
                break;
            case constants.SSG:
                event["betAmountChange"] = this.SSG_handler;
                break;
            case constants.WZD:
                event["betAmountChange"] = this.WZD_handler;
                break;
            case constants.HNR:
                event["betChanged"] = this._default;
                break;
            case constants.OAK:
                event["bet_changed"] = this._default;
                break;
            case constants.YGG:
                event["bet/changed"] = this._default;
                break;
            default:
                event["betAmountChange"] = this._default;
        }

        return event;
    }
}
